import { render } from "./Main.vue?vue&type=template&id=7fadaf0c&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=7fadaf0c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7fadaf0c"

export default script